module.exports = __webpack_public_path__ + "img/in.bdfaaf97.svg";